import failIcon from '../../assets/fail.svg';
import * as styles from '../../PaymentStatus.css';
import { Link } from '../../../../../common/Link';
import * as React from 'react';

export interface IPaymentStatusCanceledProps {
  onClick: () => void;
}

export const PaymentStatusCanceled = ({ onClick }: IPaymentStatusCanceledProps) => (
  <>
    <img src={failIcon} className={styles['icon']} data-mark="icon|fail" />
    <div className={styles['text']}>
      <Link onClick={onClick}>Проверить ещё раз</Link>
    </div>
  </>
);
